import React from 'react';
import { KeyboardAvoidingView, KeyboardAvoidingViewProps, Platform, StatusBar } from 'react-native';
import styled, { DefaultTheme, useTheme } from 'styled-components/native';
import { useKeyboard } from '@/hooks/use.keyboard';

interface Props {
  backgroundColor?: keyof DefaultTheme['colors']['screen']['background'];
  behavior?: KeyboardAvoidingViewProps['behavior'];
  children?: React.ReactNode;
}
export function BaseKeyboardAvoidingView({ backgroundColor, behavior = 'padding', children }: Props) {
  const theme = useTheme();
  const { isKeyboardVisible } = useKeyboard();
  return (
    <StyledKeyboardAvoidingView
      behavior={behavior}
      enabled={Platform.OS === 'android' && isKeyboardVisible}
      keyboardVerticalOffset={StatusBar.currentHeight || 0}
      bgColor={theme.colors.screen.background[backgroundColor]}
    >
      {children}
    </StyledKeyboardAvoidingView>
  );
}

const StyledKeyboardAvoidingView = styled(KeyboardAvoidingView)<{ bgColor: string }>`
  overflow: hidden;
  background-color: ${({ bgColor }) => bgColor};
  flex: 1;
`;

export const AppKeyboardAvoidingView = React.memo(BaseKeyboardAvoidingView);
